import numeral from "numeral";

numeral.register("locale", "se", {
  delimiters: {
    thousands: " ",
    decimal: ",",
  },
  abbreviations: {
    thousand: "T",
    million: "M",
    billion: "B",
    trillion: "TR",
  },
  currency: {
    symbol: "SEK",
  },
});

numeral.locale("se");

export class CurrencyValueConverter {
  toView(value) {
    if (value === null || value === undefined) return null;
    return numeral(value).format("0,0");
  }

  fromView(value) {
    if (value == 0) return value;
    return numeral(value).value();
  }
}
